import React, {useState, useRef, useEffect, useCallback} from 'react';
import ReactDOM from 'react-dom';
import {DATE_PICKER_STYLE} from '../../../../constants';
import Button from '../buttons/button/button';
import {BUTTON_STYLE, BUTTON_COLOR} from '../../../../constants';
import Moment from 'moment';
import Util from '../../util/util';
import Dropdown from '../dropdowns/dropdown';
import CreateTimeRegistration from '../../../../mutations/create_time_registration_mutation.modern';
import uuid from 'uuid';
import TimeRegWSuggestionsInput from '../inputs/time-registration-input/time_reg_w_sugestions_input';
import DatePicker from '../date-picker/date_picker_v3';
import TimeRegistrationIcon from '../../../../images/ico-time-registration';
import PopupStyle from '../../../../styles/components/time_reg_popup_styled';
import {injectIntl} from 'react-intl';
import {createToast} from '../toasts/another-toast/toaster';
import {EVENT_ID, dispatch, subscribe, unsubscribe} from '../../../../containers/event_manager';
import {ClickAwayListener} from '@material-ui/core';
import {showModal, MODAL_TYPE} from '../modals/generic_modal_conductor';
import {getLockedDate} from '../../../../components/timesheets/time-lock/TimeLockUtil';
import {isClientUser} from '../../util/PermissionsUtil';

const TimeRegPopup = ({viewer, projectId, task, intl: {formatMessage}}) => {
	const timeIconRef = useRef(null);
	const popupRef = useRef(null);
	const today = Moment();
	const lockedDate = getLockedDate(viewer.company, viewer);
	const todayOrEarliestSelectableDate = lockedDate && lockedDate.isSameOrAfter(today, 'day') ? lockedDate.clone().add(1, 'd') : today;

	const [id] = useState(uuid.v4());
	const [isPopupVisible, setIsPopupVisible] = useState(false);
	const [popupPosition, setPopupPosition] = useState({});
	const [arrowPosition, setArrowPosition] = useState({});
	const [selectedDate, setSelectedDate] = useState(todayOrEarliestSelectableDate);
	const [inputValue, setInputValue] = useState('');
	const [notes, setNotes] = useState('');
	const [harvestTasks, setHarvestTasks] = useState([]);
	const [selectedHarvestTask, setSelectedHarvestTask] = useState(null);
	const [selectedUnit4Activity, setSelectedUnit4Activity] = useState(null);
	const [unit4Loading, setUnit4Loading] = useState(false);
	const [unit4Activities, setUnit4Activities] = useState([]);

	let inputRef; // ref for input focus
	const handleIconClick = e => {
		e.stopPropagation();
		let arrowPositionValues = {
			left: false,
			right: false,
			bottom: false,
			top: false,
		};
		let popupPositionValues = {};
		if (timeIconRef.current) {
			const iconPosition = timeIconRef.current.getBoundingClientRect();
			let popupPosition = {};

			requestAnimationFrame(() => {
				if (popupRef.current) {
					popupPosition = popupRef.current.getBoundingClientRect();
					//check if the popup is going out of the screen update positions
					//check if there is not enough space on the right
					if (iconPosition.left + iconPosition.width / 2 + popupPosition.width / 2 > window.innerWidth) {
						arrowPositionValues.right = true;
						popupPositionValues.left = iconPosition.left - popupPosition.width - 15;
						//check if popup fits vertically
						if (window.innerHeight - iconPosition.bottom > popupPosition.height / 2) {
							popupPositionValues.bottom = window.innerHeight - iconPosition.bottom + iconPosition.height / 2 - popupPosition.height / 2;
						} else {
							arrowPositionValues.bottom = true;
							popupPositionValues.bottom = window.innerHeight - iconPosition.bottom;
						}
					}
					//check if there is not enough room on the left
					else if (iconPosition.left - popupPosition.width / 2 < 0) {
						arrowPositionValues.left = true;
						popupPositionValues.left = iconPosition.left + iconPosition.width + 15;
						//check if popup fits vertically
						if (window.innerHeight - iconPosition.bottom > popupPosition.height / 2) {
							popupPositionValues.bottom = window.innerHeight - iconPosition.bottom + iconPosition.height / 2 - popupPosition.height / 2;
						} else {
							arrowPositionValues.bottom = true;
							popupPositionValues.bottom = window.innerHeight - iconPosition.bottom;
						}
					}
					//check if there is room on the left and on the right
					else {
						popupPositionValues.left = iconPosition.left + iconPosition.width / 2 - popupPosition.width / 2;
						//check if popup fits vertically
						if (window.innerHeight - iconPosition.bottom > popupPosition.height + 15) {
							popupPositionValues.bottom = window.innerHeight - iconPosition.bottom - popupPosition.height - 15;
						} else {
							arrowPositionValues.bottom = true;
							popupPositionValues.bottom = window.innerHeight - iconPosition.bottom + iconPosition.height + 15;
						}
					}
					setPopupPosition(popupPositionValues);
					setArrowPosition(arrowPositionValues);
				}
			});
		}
		dispatch(EVENT_ID.TIME_POPUP_OPENED, task.id);
		setIsPopupVisible(!isPopupVisible);
	};

	const onScroll = useCallback(() => {
		if (isPopupVisible === true) {
			setIsPopupVisible(false);
		}
	}, [isPopupVisible]);

	const timePopupOpened = openedTaskId => {
		if (task.id !== openedTaskId) {
			setIsPopupVisible(false);
		}
	};

	const fetchHarvestTasks = project => {
		if (project) {
			if (project.id && project.harvestProject) {
				const headers = new Headers();
				headers.append('Content-Type', 'application/json');
				const init = {headers: headers, credentials: 'include'};
				fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'harvest_tasks/' + project.id, init)
					.then(result => result.json())
					.then(tasks => {
						setHarvestTasks(tasks);
					});
			} else {
				setHarvestTasks([]);
			}
		} else {
			setHarvestTasks([]);
		}
	};

	const fetchUnit4Activities = () => {
		//If project dropdown is not empty
		if (task.project) {
			//If a project is selected, show only tasks that belong to that project
			if (task.project.id && task.project.unit4Project) {
				if (unit4Loading === true) return;
				if (unit4Activities.length === 0) {
					setUnit4Loading(true);
				}
				const headers = new Headers();
				headers.append('Content-Type', 'application/json');
				const init = {headers: headers, credentials: 'include'};
				fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'unit4_activities/' + task.project.id, init)
					.then(result => result.json())
					.then(activities => {
						setUnit4Activities(activities.map(activity => ({label: activity.name, value: activity.id})));
						setUnit4Loading(false);
					});
			} else {
				setUnit4Activities([]);
				setUnit4Loading(false);
			}
		} else {
			setUnit4Activities([]);
			setUnit4Loading(false);
		}
	};

	useEffect(() => {
		subscribe(EVENT_ID.SCROLLED, onScroll);
		subscribe(EVENT_ID.TIME_POPUP_OPENED, timePopupOpened);
		return () => {
			unsubscribe(EVENT_ID.SCROLLED, onScroll);
			unsubscribe(EVENT_ID.TIME_POPUP_OPENED, timePopupOpened);
		};
	}, []);

	useEffect(() => {
		if (isPopupVisible) {
			fetchHarvestTasks(task.project);
			document.addEventListener('wheel', onScroll);
			return () => {
				document.removeEventListener('wheel', onScroll);
			};
		}
	}, [isPopupVisible]);

	useEffect(() => {
		if (lockedDate && lockedDate.isSameOrAfter(selectedDate, 'day')) {
			setSelectedDate(lockedDate.clone().add(1, 'd'));
		}
	}, [lockedDate]);

	const resetFields = () => {
		setSelectedDate(todayOrEarliestSelectableDate);
		setInputValue('');
		setNotes('');
	};

	const onPopupClick = e => {
		e.target.focus();

		e.stopPropagation();
	};

	const handleDateSelect = date => {
		setSelectedDate(date);
	};

	const handleHarvestTaskChange = task => {
		setSelectedHarvestTask(task);
	};

	const handleUnit4ActivityChange = activity => {
		setSelectedUnit4Activity(activity);
	};

	const handleNotesChange = e => {
		const note = e.target ? e.target.value : '';
		setNotes(note);
	};

	const handleCancelButtonPress = () => {
		resetFields();
		setIsPopupVisible(false);
	};

	const handleAddButtonPress = e => {
		const onSuccess = result => {
			if (result.createTimeReg.errors && result.createTimeReg.errors.length === 1 && result.createTimeReg.errors[0] === 'TIME_REGISTRATION_IN_LOCKED_PERIOD') {
				showModal({
					type: MODAL_TYPE.WARNING_DATE_LOCKED,
				});
			} else {
				createToast({
					duration: 5000,
					message: formatMessage({id: 'common.time_entry_added'}),
				});

				resetFields();
				setIsPopupVisible(false);
			}
		};
		if (!isNaN(inputValue) && inputValue !== null && inputValue !== '') {
			Util.CommitMutation(
				CreateTimeRegistration,
				{
					viewer: viewer,
					projectId: projectId,
					taskId: task.id,
					subTask: !!task.parentTaskId,
					source: 'Time-reg-popup',
					idleTimeId: null,
					minutesRegistered: inputValue,
					day: selectedDate.date(),
					month: selectedDate.month() + 1,
					year: selectedDate.year(),
					personId: viewer.actualPersonId,
					notes: notes.length ? notes : null,
					harvestTaskId: selectedHarvestTask ? selectedHarvestTask.value : null,
					unit4ActivityId: selectedUnit4Activity ? selectedUnit4Activity.value : null,
					unit4ActivityName: selectedUnit4Activity ? selectedUnit4Activity.label : null,
					newFormat: true,
				},
				onSuccess
			);
		} else {
			inputRef && inputRef.focus();
		}
	};

	const onChildComponentBlur = () => {
		if (isPopupVisible) {
			resetFields();
			setIsPopupVisible(false);
		}
	};

	const setSuggestedValueToInput = value => {
		if (isNaN(value)) {
			setInputValue(null);
		} else {
			setInputValue(Util.convertTimeInputToMinutes(value));
		}
	};

	// Dirty hack to prevent drag events from bubbling out from portal
	const onMouseDown = e => {
		e.stopPropagation();
	};

	const harvestTaskOptions = harvestTasks
		? harvestTasks.map(harvestTask => {
				return {value: harvestTask.id, label: harvestTask.name};
		  })
		: [];

	return isClientUser() ? null : (
		<React.Fragment>
			<TimeRegistrationIcon ref={timeIconRef} active={isPopupVisible} onClick={handleIconClick} isPopupVisible={isPopupVisible} />
			{isPopupVisible
				? ReactDOM.createPortal(
						<ClickAwayListener onClickAway={onChildComponentBlur}>
							<PopupStyle onMouseDown={onMouseDown} onClick={onPopupClick} onContextMenu={onPopupClick} popupPosition={popupPosition} arrowPosition={arrowPosition} ref={popupRef}>
								<div className="popup-wrapper">
									<div className="entry-wrapper">
										<div className="title">{formatMessage({id: 'common.new_time_entry_popup_title'})}</div>
									</div>
									<div className="entry-wrapper">
										<TimeRegWSuggestionsInput
											id={id}
											initialValue={inputValue}
											onInputChange={value => {
												setSuggestedValueToInput(value);
											}}
											changeOnlyOnValid={false}
											date={selectedDate}
											task={task}
											viewer={viewer}
											innerRef={div => (inputRef = div)}
											cy={'time-entry-pop-up'}
										/>
									</div>
									{task.project && task.project.harvestProject && viewer.harvestUser && viewer.company.harvestEnabled ? (
										<div className="entry-wrapper">
											<Dropdown
												inputClassName="harvest-dropdown"
												focusOnClick={true}
												options={harvestTaskOptions}
												onChange={handleHarvestTaskChange}
												value={selectedHarvestTask ? selectedHarvestTask.value : ''}
												label={formatMessage({id: 'card_modal.harvest_task'})}
												multi={false}
												clearable={true}
												customHeight={30}
												placeholder={formatMessage({id: 'card_modal.harvest_task_placeholder'})}
											/>
										</div>
									) : null}
									{task.project && task.project.unit4Project && task.project.unit4Project.activitiesEnabled && viewer.unit4User && viewer.company.unit4Enabled ? (
										<div className="entry-wrapper">
											<Dropdown
												value={selectedUnit4Activity ? selectedUnit4Activity.value : null}
												options={unit4Activities}
												onChange={handleUnit4ActivityChange}
												label={formatMessage({id: 'integrations.unit4_activity'})}
												placeholder={formatMessage({id: 'integrations.unit4_activity_placeholder'})}
												customHeight={30}
												onClick={fetchUnit4Activities}
												integrationDropdown={true}
												integrationLoading={unit4Loading}
												integrationRetryToFetch={fetchUnit4Activities}
											/>
										</div>
									) : null}
									<div className="entry-wrapper">
										<div className="datepicker">
											<div className="input-title">{formatMessage({id: 'common.date'})}</div>
											<DatePicker
												startDate={selectedDate}
												handleDateRangeChange={handleDateSelect}
												datePickerStyle={DATE_PICKER_STYLE.STANDARD}
												isSingleDatePicker={true}
												disabled={false}
												startDateLimite={lockedDate && lockedDate.clone().add(1, 'd')}
											/>
										</div>
									</div>
									<div className="entry-wrapper">
										<div className="notes">
											<div className="input-title">{formatMessage({id: 'common.notes'})}</div>
											<textarea
												maxLength={viewer.company.characterLimit > -1 ? viewer.company.characterLimit : 999}
												rows={5}
												cols={40}
												placeholder={formatMessage({id: 'overview_time.write_your_notes'})}
												onChange={handleNotesChange.bind(this)}
											/>
										</div>
									</div>
									<div className="buttons">
										<Button
											cy="cancel-button"
											text={formatMessage({id: 'common.cancel'})}
											buttonStyle={BUTTON_STYLE.FILLED}
											colorTheme={BUTTON_COLOR.WHITE}
											onClick={handleCancelButtonPress}
											focusOnMouseDown={true} // need to focus on the button when clicking down to trigger the blur effect on the input to tranform string to hours amount
											focusOnClick={true}
										/>
										<Button
											cy="add-new-time-entry-button"
											text={formatMessage({id: 'common.add'})}
											buttonStyle={BUTTON_STYLE.FILLED}
											colorTheme={BUTTON_COLOR.GREEN}
											onClick={handleAddButtonPress}
											focusOnMouseDown={true}
											focusOnClick={true}
											isDisabled={(task.project && task.project.harvestProject && viewer.harvestUser && viewer.company.harvestEnabled && !selectedHarvestTask) || inputValue == null}
										/>
									</div>
								</div>
							</PopupStyle>
						</ClickAwayListener>,
						document.querySelector('#root-portal-container')
				  )
				: null}
		</React.Fragment>
	);
};

export default injectIntl(TimeRegPopup);
